import React from 'react';
import { useLanguage } from '../context/LanguageContext';
var Spinner = require('react-spinkit');

const RestaurauntOwners = () => {
    const [loaded, setLoaded] = React.useState(false);
    const { translate } = useLanguage();

    return (
        <main>
            <section className="page-header">
                <div className="container">
                    <h1>{translate('RESTAURANT_OWNERS_HEADER_TITLE')}</h1>
                    {/* <p className="page-subtitle">{translate('REPORT_HEADER_SUBTITLE')}</p> */}
                </div>
            </section>

            <section className="report-incident">
                <div className="container">
                    {/* <div
                    className="report-incident-form"
                    dangerouslySetInnerHTML={{ __html: incidentReportingForm }}
                /> */}
                    {!loaded ? (
                        <div className="spinner-container">
                            <Spinner
                                className="loading text-center"
                                name="three-bounce"
                                color="black"
                                fadeIn="none"
                            />
                        </div>
                    ) : null}
                    <iframe
                        className='report-incident-form'
                        src="https://airtable.com/embed/appN9G9Cik3kC1FAT/pagyx62w7ndjgbMXT/form"
                        width="100%"
                        height="1800"
                        frameBorder="0"
                        onLoad={() => { setLoaded(true); }}
                    />
                </div>
            </section>
        </main>
    );
};

export default RestaurauntOwners;